import type { App } from "vue";
import animatePop from "@/directives/animatePop";

export default {
  install(app: App) {
    app.directive("animate-pop", animatePop);
  },
};
